import { render, staticRenderFns } from "./QuotaFull.vue?vue&type=template&id=6d427eac&"
import script from "./QuotaFull.vue?vue&type=script&lang=js&"
export * from "./QuotaFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports